import { IApiLpBase } from './IApiLp';

/** Request body for creating/updating a schedule */
export interface IApiScheduleData {
  name: string;
  city: string;
  cloneScheduleId?: number;
}

export interface IApiSchedule {
  id: number;
  name: string;
  city: string;
  /** @deprecated offset from API response, not used for writes */
  timezone?: number;
}

export interface IApiScheduleFullView extends IApiSchedule {
  pricingIntervals: IApiScheduleIntervalDay[];
  tradingIntervals: IApiScheduleIntervalDay[];
}

export interface IApiScheduleDetails extends IApiScheduleFullView {
  coreSymbolCount?: number;
  lps?: IApiLpBase[];
}

export interface IApiScheduleInterval {
  /**
   * Day of week, Sunday=0
   */
  endDayOfWeek: number;
  /**
   * Number of seconds from start of day(endDayOfWeek)
   */
  endTime: number;
  /**
   * Day of week, Sunday=0
   */
  startDayOfWeek: number;
  /**
   * Number of seconds from start of day (startDayOfWeek)
   */
  startTime: number;
  type: ApiScheduleIntervalType;
}

export enum ApiScheduleIntervalType {
  Pricing = 'PRICING',
  PricingAndTrading = 'PRICING_AND_TRADING',
  Trading = 'TRADING',
}

export interface IApiScheduleIntervalDay {
  /**
   * Day of week, Sunday=0
   */
  dayOfWeek: number;
  /**
   * Number of seconds from start of day
   */
  end: number;
  /**
   * Number of seconds from start of day
   */
  start: number;
}
